module.exports = __webpack_public_path__ + "img/chain04.57a84b26.png";